
import { Base } from '../../components/base-component';

import { AnalyticsService } from '../../services/analytics.service';

import './form-item-win-a-car.component.scss';

export class FormItemWinACar extends Base {

	form: HTMLFormElement;
	submitBtn: Element;

	constructor(element: Element) {
		super(element);
	}

	init() {

		this.form = this.element.querySelector('form') as HTMLFormElement;
		this.submitBtn = this.element.querySelector('.js-win-a-car__button');

	}

	bindEvents() {
		
		this.submitBtn.addEventListener('click', (event) => {
			const formFields: any = this.form.querySelectorAll('input, select');
			const validation = this.validationService.validate(formFields);
			const valid = Array.from(this.form.querySelectorAll(".form__group--error"));
			if (valid.length == 0) {
				this.actionForm(this.form, this.element.querySelector('.form__loader--container'), this.element.querySelector('.form__thankyou--container'));
			}
		});
	}

	actionForm(form: HTMLFormElement, loader: Element, thankyou: Element) {

		let _records = [];
		let name = Array.from(form.querySelectorAll('.form__success-container__firstname'));

		// paremeters
		let _firstName: any = this.form.querySelector('input[name=first-name]');
		let _lastName: any = this.form.querySelector('input[name=last-name]');
		let _idNumber: any = this.form.querySelector('input[name=id-number]');
		let _phoneNumber: any = this.form.querySelector('input[name=phone-number]');
		

		// additional containers
		let success = form.querySelector('.form__success--container');
		let error = form.querySelector('.form__error--container');

		let postData = '';

		if (_firstName) {
			postData += 'firstname=' + _firstName.value;
		}
		if (_lastName) {
			postData += '&surname=' + _lastName.value;
		}
		if (_idNumber) {
			postData += '&saId=' + _idNumber.value;
		}
		if (_phoneNumber) {
			postData += '&contact=' + _phoneNumber.value;
		}

		// loader + hide form
		const fieldsContainer: any = form.querySelector('.form__fields--container');
		loader.classList.add('active');
		fieldsContainer.classList.add('hidden');

		// variables
		let analyticsService = new AnalyticsService();
		let url = "/services/carcampaignservice.jsp";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}

		// service
		this.formsService.postForm(url, postData, config).then(function (response) {
			loader.classList.remove('active');
			if (!response.data || (response.data == 'invalid')) {
				analyticsService.dtmRecordSiteError('noerrorcode|invalid response');
				loader.classList.remove('active');
				error.classList.add('active');
				thankyou.classList.add('active');
				success.classList.add('hidden');
			} else {
				analyticsService.dtmFormComplete('complete', response.code);
				loader.classList.remove('active');
				thankyou.classList.add('active');
				success.classList.add('active');
				error.classList.add('hidden');
			}
		}).catch(function (response) {
			// service failed
			analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
			loader.classList.remove('active');
			fieldsContainer.classList.remove('hidden');
		});
	}

}



// WEBPACK FOOTER //
// ./components-wpbbsa/form-item-win-a-car/form-item-win-a-car.component.ts